import React, { useState, useRef } from 'react';
import { HomeIcon, Menu, X } from 'lucide-react';
import { useLocation } from 'react-router-dom';
export const Header: React.FC = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isAboutPage = location.pathname === '/about' || location.pathname.startsWith('/about/');
  const isProfilPage = location.pathname === '/about/profil';
  const isQualifikationenPage = location.pathname === '/about/qualifikationen';
  const isArbeitsweisePage = location.pathname === '/about/arbeitsweise';
  const isCoachingPage = location.pathname === '/coaching' || location.pathname.startsWith('/coaching/') && location.pathname !== '/coaching/mentale-gesundheit';
  const isKarriereCoachingPage = location.pathname === '/coaching/karriere';
  const isFuehrungsCoachingPage = location.pathname === '/coaching/fuehrung';
  const isMentaleGesundheitPage = location.pathname === '/coaching/mentale-gesundheit';
  const isManagementPage = location.pathname === '/management-diagnostik' || location.pathname.startsWith('/management-diagnostik/');
  const isPotenzialanalysenPage = location.pathname === '/management-diagnostik/potenzialanalysen';
  const isAssessmentCenterPage = location.pathname === '/management-diagnostik/assessment-center';
  const isInterviewtrainingPage = location.pathname === '/management-diagnostik/interviewtraining';
  const isChangeBeratungPage = location.pathname === '/change-beratung' || location.pathname.startsWith('/change-beratung/');
  const isKonzeptionPage = location.pathname === '/change-beratung/konzeption-umsetzung';
  const isTeamentwicklungPage = location.pathname === '/change-beratung/teamentwicklung';
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState<string | null>(null);
  const closeTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const handleMouseEnter = (dropdown: string) => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
    setActiveDropdown(dropdown);
  };
  const handleMouseLeave = () => {
    closeTimeoutRef.current = setTimeout(() => {
      setActiveDropdown(null);
    }, 200);
  };
  const toggleMobileDropdown = (dropdown: string) => {
    setMobileDropdownOpen(mobileDropdownOpen === dropdown ? null : dropdown);
  };
  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setMobileDropdownOpen(null);
  };
  return <header className="w-full bg-white py-4 px-6 md:px-12 xl:px-20 border-b border-gray-300" data-id="element-87">
      <div className="max-w-6xl mx-auto flex justify-between items-center" data-id="element-88">
        <a href="/" className="logo" data-id="element-89">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/15XC1iDXRVhukoKXVMtBJg/wandelwert_logo.svg" alt="wandelwert Logo" className="h-14 cursor-pointer" data-id="element-90" />
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden xl:flex items-center space-x-8" data-id="element-91">
          <a href="/" className={isHomePage ? 'text-orange-500 hover:text-orange-600' : 'text-gray-700 hover:text-orange-500'} data-id="element-92">
            <HomeIcon size={24} data-id="element-93" />
          </a>

          <div className="relative" onMouseEnter={() => handleMouseEnter('about')} onMouseLeave={handleMouseLeave} data-id="element-94">
            <a href="/about" className={isAboutPage ? 'text-orange-500 hover:text-orange-600 text-lg' : 'text-gray-700 hover:text-orange-500 text-lg'} data-id="element-95">
              About
            </a>
            <div className="absolute top-full left-0 pt-2 z-50 overflow-hidden transition-all duration-300 ease-out" style={{
            maxHeight: activeDropdown === 'about' ? '500px' : '0px',
            opacity: activeDropdown === 'about' ? 1 : 0
          }} data-id="element-96">
              <div className="bg-white shadow-lg border border-gray-200 py-2 min-w-[200px]" data-id="element-97">
                <a href="/about/profil" className={`block px-4 py-2 hover:bg-gray-50 ${isProfilPage ? 'text-orange-500' : 'text-gray-700 hover:text-orange-500'}`} data-id="element-98">
                  Profil
                </a>
                <a href="/about/qualifikationen" className={`block px-4 py-2 hover:bg-gray-50 ${isQualifikationenPage ? 'text-orange-500' : 'text-gray-700 hover:text-orange-500'}`} data-id="element-99">
                  Qualifikationen
                </a>
                <a href="/about/arbeitsweise" className={`block px-4 py-2 hover:bg-gray-50 ${isArbeitsweisePage ? 'text-orange-500' : 'text-gray-700 hover:text-orange-500'}`} data-id="element-100">
                  Meine Arbeitsweise
                </a>
              </div>
            </div>
          </div>

          <div className="relative" onMouseEnter={() => handleMouseEnter('coaching')} onMouseLeave={handleMouseLeave} data-id="element-101">
            <a href="/coaching" className={isCoachingPage ? 'text-orange-500 hover:text-orange-600 text-lg' : 'text-gray-700 hover:text-orange-500 text-lg'} data-id="element-102">
              Coaching
            </a>
            <div className="absolute top-full left-0 pt-2 z-50 overflow-hidden transition-all duration-300 ease-out" style={{
            maxHeight: activeDropdown === 'coaching' ? '500px' : '0px',
            opacity: activeDropdown === 'coaching' ? 1 : 0
          }} data-id="element-103">
              <div className="bg-white shadow-lg border border-gray-200 py-2 min-w-[200px]" data-id="element-104">
                <a href="/coaching/karriere" className={`block px-4 py-2 hover:bg-gray-50 ${isKarriereCoachingPage ? 'text-orange-500' : 'text-gray-700 hover:text-orange-500'}`} data-id="element-105">
                  Karriere Coaching
                </a>
                <a href="/coaching/fuehrung" className={`block px-4 py-2 hover:bg-gray-50 ${isFuehrungsCoachingPage ? 'text-orange-500' : 'text-gray-700 hover:text-orange-500'}`} data-id="element-106">
                  Führungs Coaching
                </a>
              </div>
            </div>
          </div>

          <a href="/coaching/mentale-gesundheit" className={isMentaleGesundheitPage ? 'text-orange-500 hover:text-orange-600 text-lg' : 'text-gray-700 hover:text-orange-500 text-lg'} data-id="element-107">
            Mentale Gesundheit
          </a>

          <div className="relative" onMouseEnter={() => handleMouseEnter('diagnostik')} onMouseLeave={handleMouseLeave} data-id="element-108">
            <a href="/management-diagnostik" className={isManagementPage ? 'text-orange-500 hover:text-orange-600 text-lg' : 'text-gray-700 hover:text-orange-500 text-lg'} data-id="element-109">
              Management Diagnostik
            </a>
            <div className="absolute top-full left-0 pt-2 z-50 overflow-hidden transition-all duration-300 ease-out" style={{
            maxHeight: activeDropdown === 'diagnostik' ? '500px' : '0px',
            opacity: activeDropdown === 'diagnostik' ? 1 : 0
          }} data-id="element-110">
              <div className="bg-white shadow-lg border border-gray-200 py-2 min-w-[200px]" data-id="element-111">
                <a href="/management-diagnostik/potenzialanalysen" className={`block px-4 py-2 hover:bg-gray-50 ${isPotenzialanalysenPage ? 'text-orange-500' : 'text-gray-700 hover:text-orange-500'}`} data-id="element-112">
                  Potenzialanalysen
                </a>
                <a href="/management-diagnostik/assessment-center" className={`block px-4 py-2 hover:bg-gray-50 ${isAssessmentCenterPage ? 'text-orange-500' : 'text-gray-700 hover:text-orange-500'}`} data-id="element-113">
                  Assessment Center
                </a>
                <a href="/management-diagnostik/interviewtraining" className={`block px-4 py-2 hover:bg-gray-50 ${isInterviewtrainingPage ? 'text-orange-500' : 'text-gray-700 hover:text-orange-500'}`} data-id="element-114">
                  Interviewtraining
                </a>
              </div>
            </div>
          </div>

          <div className="relative" onMouseEnter={() => handleMouseEnter('change')} onMouseLeave={handleMouseLeave} data-id="element-115">
            <a href="/change-beratung" className={isChangeBeratungPage ? 'text-orange-500 hover:text-orange-600 text-lg' : 'text-gray-700 hover:text-orange-500 text-lg'} data-id="element-116">
              Change Beratung
            </a>
            <div className="absolute top-full left-0 pt-2 z-50 overflow-hidden transition-all duration-300 ease-out" style={{
            maxHeight: activeDropdown === 'change' ? '500px' : '0px',
            opacity: activeDropdown === 'change' ? 1 : 0
          }} data-id="element-117">
              <div className="bg-white shadow-lg border border-gray-200 py-2 min-w-[240px]" data-id="element-118">
                <a href="/change-beratung/konzeption-umsetzung" className={`block px-4 py-2 hover:bg-gray-50 whitespace-nowrap ${isKonzeptionPage ? 'text-orange-500' : 'text-gray-700 hover:text-orange-500'}`} data-id="element-119">
                  Konzeption und Umsetzung
                </a>
                <a href="/change-beratung/teamentwicklung" className={`block px-4 py-2 hover:bg-gray-50 ${isTeamentwicklungPage ? 'text-orange-500' : 'text-gray-700 hover:text-orange-500'}`} data-id="element-120">
                  Teamentwicklung
                </a>
              </div>
            </div>
          </div>
        </nav>

        {/* Mobile Menu Button */}
        <button className="xl:hidden text-gray-700 hover:text-orange-500" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-121">
          {mobileMenuOpen ? <X size={28} data-id="element-122" /> : <Menu size={28} data-id="element-123" />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && <nav className="xl:hidden mt-4 pb-4 border-t border-gray-200" data-id="element-124">
          <div className="flex flex-col space-y-2 pt-4" data-id="element-125">
            <a href="/" onClick={closeMobileMenu} className={`flex items-center px-4 py-2 ${isHomePage ? 'text-orange-500' : 'text-gray-700'}`} data-id="element-126">
              <HomeIcon size={20} className="mr-2" data-id="element-127" />
              Home
            </a>

            {/* About Dropdown */}
            <div data-id="element-128">
              <button onClick={() => toggleMobileDropdown('about')} className={`w-full text-left px-4 py-2 flex justify-between items-center ${isAboutPage ? 'text-orange-500' : 'text-gray-700'}`} data-id="element-129">
                About
                <span className="text-sm" data-id="element-130">
                  {mobileDropdownOpen === 'about' ? '−' : '+'}
                </span>
              </button>
              {mobileDropdownOpen === 'about' && <div className="pl-8 space-y-1" data-id="element-131">
                  <a href="/about/profil" onClick={closeMobileMenu} className={`block px-4 py-2 ${isProfilPage ? 'text-orange-500' : 'text-gray-700'}`} data-id="element-132">
                    Profil
                  </a>
                  <a href="/about/qualifikationen" onClick={closeMobileMenu} className={`block px-4 py-2 ${isQualifikationenPage ? 'text-orange-500' : 'text-gray-700'}`} data-id="element-133">
                    Qualifikationen
                  </a>
                  <a href="/about/arbeitsweise" onClick={closeMobileMenu} className={`block px-4 py-2 ${isArbeitsweisePage ? 'text-orange-500' : 'text-gray-700'}`} data-id="element-134">
                    Meine Arbeitsweise
                  </a>
                </div>}
            </div>

            {/* Coaching Dropdown */}
            <div data-id="element-135">
              <button onClick={() => toggleMobileDropdown('coaching')} className={`w-full text-left px-4 py-2 flex justify-between items-center ${isCoachingPage ? 'text-orange-500' : 'text-gray-700'}`} data-id="element-136">
                Coaching
                <span className="text-sm" data-id="element-137">
                  {mobileDropdownOpen === 'coaching' ? '−' : '+'}
                </span>
              </button>
              {mobileDropdownOpen === 'coaching' && <div className="pl-8 space-y-1" data-id="element-138">
                  <a href="/coaching/karriere" onClick={closeMobileMenu} className={`block px-4 py-2 ${isKarriereCoachingPage ? 'text-orange-500' : 'text-gray-700'}`} data-id="element-139">
                    Karriere Coaching
                  </a>
                  <a href="/coaching/fuehrung" onClick={closeMobileMenu} className={`block px-4 py-2 ${isFuehrungsCoachingPage ? 'text-orange-500' : 'text-gray-700'}`} data-id="element-140">
                    Führungs Coaching
                  </a>
                </div>}
            </div>

            {/* Mentale Gesundheit - Direct Link */}
            <a href="/coaching/mentale-gesundheit" onClick={closeMobileMenu} className={`block px-4 py-2 ${isMentaleGesundheitPage ? 'text-orange-500' : 'text-gray-700'}`} data-id="element-141">
              Mentale Gesundheit
            </a>

            {/* Management Diagnostik Dropdown */}
            <div data-id="element-142">
              <button onClick={() => toggleMobileDropdown('diagnostik')} className={`w-full text-left px-4 py-2 flex justify-between items-center ${isManagementPage ? 'text-orange-500' : 'text-gray-700'}`} data-id="element-143">
                Management Diagnostik
                <span className="text-sm" data-id="element-144">
                  {mobileDropdownOpen === 'diagnostik' ? '−' : '+'}
                </span>
              </button>
              {mobileDropdownOpen === 'diagnostik' && <div className="pl-8 space-y-1" data-id="element-145">
                  <a href="/management-diagnostik/potenzialanalysen" onClick={closeMobileMenu} className={`block px-4 py-2 ${isPotenzialanalysenPage ? 'text-orange-500' : 'text-gray-700'}`} data-id="element-146">
                    Potenzialanalysen
                  </a>
                  <a href="/management-diagnostik/assessment-center" onClick={closeMobileMenu} className={`block px-4 py-2 ${isAssessmentCenterPage ? 'text-orange-500' : 'text-gray-700'}`} data-id="element-147">
                    Assessment Center
                  </a>
                  <a href="/management-diagnostik/interviewtraining" onClick={closeMobileMenu} className={`block px-4 py-2 ${isInterviewtrainingPage ? 'text-orange-500' : 'text-gray-700'}`} data-id="element-148">
                    Interviewtraining
                  </a>
                </div>}
            </div>

            {/* Change Beratung Dropdown */}
            <div data-id="element-149">
              <button onClick={() => toggleMobileDropdown('change')} className={`w-full text-left px-4 py-2 flex justify-between items-center ${isChangeBeratungPage ? 'text-orange-500' : 'text-gray-700'}`} data-id="element-150">
                Change Beratung
                <span className="text-sm" data-id="element-151">
                  {mobileDropdownOpen === 'change' ? '−' : '+'}
                </span>
              </button>
              {mobileDropdownOpen === 'change' && <div className="pl-8 space-y-1" data-id="element-152">
                  <a href="/change-beratung/konzeption-umsetzung" onClick={closeMobileMenu} className={`block px-4 py-2 ${isKonzeptionPage ? 'text-orange-500' : 'text-gray-700'}`} data-id="element-153">
                    Konzeption und Umsetzung
                  </a>
                  <a href="/change-beratung/teamentwicklung" onClick={closeMobileMenu} className={`block px-4 py-2 ${isTeamentwicklungPage ? 'text-orange-500' : 'text-gray-700'}`} data-id="element-154">
                    Teamentwicklung
                  </a>
                </div>}
            </div>
          </div>
        </nav>}
    </header>;
};